import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAdmin } from '../../contexts/AdminContext';
import AdminSidebar from './AdminSidebar';
import { BellIcon, SearchIcon, MenuIcon } from 'lucide-react';
const AdminLayout = () => {
  const {
    isAuthenticated
  } = useAdmin();
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/admin/login', {
        state: {
          from: location.pathname
        }
      });
    }
  }, [isAuthenticated, navigate, location]);
  // Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);
  if (!isAuthenticated) return null;
  return <div className="flex min-h-screen bg-gray-100 font-sans" data-id="element-115">
      {/* Desktop Sidebar */}
      <div className="hidden md:block" data-id="element-116">
        <AdminSidebar collapsed={collapsed} setCollapsed={setCollapsed} data-id="element-117" />
      </div>

      {/* Mobile Sidebar Overlay */}
      {mobileMenuOpen && <div className="md:hidden fixed inset-0 z-50 flex" data-id="element-118">
          <div className="fixed inset-0 bg-black/50" onClick={() => setMobileMenuOpen(false)} data-id="element-119"></div>
          <div className="relative z-10 w-64 h-full" data-id="element-120">
            <AdminSidebar collapsed={false} setCollapsed={() => {}} data-id="element-121" />
          </div>
        </div>}

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden" data-id="element-122">
        {/* Topbar */}
        <header className="h-16 bg-white border-b border-gray-200 flex items-center justify-between px-4 lg:px-8 sticky top-0 z-30" data-id="element-123">
          <div className="flex items-center gap-4" data-id="element-124">
            <button className="md:hidden p-2 text-gray-500 hover:bg-gray-100 rounded-lg" onClick={() => setMobileMenuOpen(true)} data-id="element-125">
              <MenuIcon size={24} data-id="element-126" />
            </button>
            <div className="hidden sm:flex items-center bg-gray-100 px-3 py-2 rounded-lg border border-gray-200 focus-within:border-blue-500 focus-within:ring-1 focus-within:ring-blue-500 transition-all w-64 lg:w-96" data-id="element-127">
              <SearchIcon size={18} className="text-gray-400 mr-2" data-id="element-128" />
              <input type="text" placeholder="Search anything..." className="bg-transparent border-none outline-none w-full text-sm text-gray-700 placeholder-gray-400" data-id="element-129" />
            </div>
          </div>

          <div className="flex items-center gap-4" data-id="element-130">
            <button className="relative p-2 text-gray-500 hover:bg-gray-100 rounded-full transition-colors" data-id="element-131">
              <BellIcon size={20} data-id="element-132" />
              <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-red-500 rounded-full border-2 border-white" data-id="element-133"></span>
            </button>
            <a href="/" target="_blank" rel="noopener noreferrer" className="hidden sm:block text-sm font-medium text-blue-600 hover:text-blue-800 hover:underline" data-id="element-134">
              View Live Site
            </a>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 overflow-y-auto p-4 md:p-6 lg:p-8" data-id="element-135">
          <div className="max-w-7xl mx-auto" data-id="element-136">
            <Outlet data-id="element-137" />
          </div>
        </main>
      </div>
    </div>;
};
export default AdminLayout;